"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* istanbul ignore file */
var INetworkAdapter = /*#__PURE__*/function () {
  function INetworkAdapter() {
    (0, _classCallCheck2["default"])(this, INetworkAdapter);
  }
  return (0, _createClass2["default"])(INetworkAdapter, [{
    key: "get",
    value: function get() {}
  }, {
    key: "post",
    value: function post() {}
  }, {
    key: "put",
    value: function put() {}
  }, {
    key: "delete",
    value: function _delete() {}
  }]);
}();
exports = module.exports = INetworkAdapter;